// Import base components
import { httpV2 } from "../http.js";

const MessagesService = {
  sendMessage: (objMessage) => httpV2.post("messaging/outbound", objMessage),
};

export default MessagesService;
